import React from "react";
import S from "./CtaCard.styled";
import { Flex, MainInner, MainSection, motionAnimation } from "@/styles/global";
import { isLight } from "@/src/helpers";
import { DisplayHeadingS, H3 } from "@/styles/typography";
import {
  ColorOptions,
  IWPImage,
  IWPLink,
  IWPTitleParts,
  IWPVideo,
} from "@/src/types";
import { TextButton, Image } from "@/styles/components";
import Youtube from "@/components/global-components/Youtube";
import TitleParts from "@/components/global-components/TitleParts";
import { motion } from "framer-motion";

export interface CtaCardProps {
  blockId: string;
  mediaType: "image" | "video";
  image: {
    image: IWPImage;
    imageText?: string;
    textBackground: "fill" | "gradient";
  };
  video: IWPVideo;
  text: string;
  titleParts: IWPTitleParts;
  title: string;
  link: IWPLink;
  alignText?: "left" | "right";
  backgroundColor: ColorOptions;
  backgroundType: "card" | "fill";
}

const CtaCard: React.FC<CtaCardProps> = ({
  blockId = "",
  mediaType,
  video,
  titleParts,
  title,
  text,
  link,
  image,
  alignText,
  backgroundColor,
  backgroundType,
}) => {
  const alignTextLeft = alignText === "left";

  return (
    <S.Section as={motion.section} {...motionAnimation} id={blockId}>
      <S.Inner
        $backgroundType={backgroundType}
        $backgroundColor={backgroundColor}
      >
        <S.Card
          $backgroundColor={backgroundColor}
          $left={alignTextLeft}
          $backgroundType={backgroundType}
        >
          {mediaType === "video" ? (
            <Youtube video={video} />
          ) : (
            <S.ImageWrapper>
              <Image
                image={image.image}
                radius={10}
                height={"100%"}
                imageText={image.imageText}
                textBackground={image.textBackground}
              />
            </S.ImageWrapper>
          )}
          <Flex $dir="column" $gap={24} $width={"100%"}>
            {text && (
              <H3
                color={
                  backgroundColor === "yellow"
                    ? "brown"
                    : isLight(backgroundColor)
                      ? "black"
                      : "creme"
                }
                weight={700}
              >
                {text}
              </H3>
            )}
            <DisplayHeadingS
              color={
                backgroundColor === "yellow"
                  ? "brown"
                  : isLight(backgroundColor)
                    ? "black"
                    : "creme"
              }
            >
              {titleParts ? (
                <TitleParts
                  titleParts={titleParts}
                  backgroundColor={backgroundColor}
                />
              ) : (
                title && title
              )}
            </DisplayHeadingS>
            <TextButton wpLink={link} />
          </Flex>
        </S.Card>
      </S.Inner>
    </S.Section>
  );
};

export default CtaCard;
